import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import FAQ from './faq'
import Footer from '../../components/footer/Footer';
import Navbar3 from '../../components/Navbar3/Navbar3';
import TermsOfUse from '../../components/TermsOfUse/TermsOfUse';

const TermPage = (props) => {


    return (
        <Fragment>
              <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
             <Navbar3 topbarNone={"wpo-header-style-6"} />
            <PageTitle pageTitle={'Terms Of Use'} backgroundImage={require("../../images/ts.jpeg")}/> 
            <TermsOfUse/>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default TermPage;
